import { Link } from 'react-router-dom'
import { exceptionLabel, humanize, subjectLabel } from '../labels'
import { Severity, Status, When } from './bits'

export interface ExceptionLiteRow {
  id: string
  type: string
  severity: string
  status: string
  subjectType: string
  raisedAt: string | null
  resolutionCode?: string | null
}

/** Compact exception list for detail pages; each row opens it in the queue. */
export function ExceptionTable({ rows, compact }: { rows: ExceptionLiteRow[]; compact?: boolean }) {
  if (rows.length === 0) return <p className="px-4 py-3 text-[14px] text-muted">No exceptions.</p>
  const sorted = [...rows].sort((a, b) => (a.status === 'OPEN' ? -1 : 1) - (b.status === 'OPEN' ? -1 : 1))
  return (
    <ul className="divide-y divide-rule/70">
      {sorted.map((e) => {
        const l = exceptionLabel(e.type)
        return (
          <li key={e.id}>
            <Link to={`/c/exceptions?open=${e.id}`} className="flex items-start justify-between gap-3 px-4 py-2.5 hover:bg-paper-tint/60">
              <span className="min-w-0">
                <span className="block text-[14px] text-ink">{l.en}</span>
                <span className="block text-[12px] text-muted">
                  {subjectLabel(e.subjectType)}
                  {!compact && e.raisedAt && <> · <When at={e.raisedAt} /></>}
                  {e.resolutionCode && <> · {humanize(e.resolutionCode)}</>}
                </span>
              </span>
              <span className="flex shrink-0 flex-col items-end gap-1">
                <Severity severity={e.severity} />
                {e.status !== 'OPEN' && <Status status={e.status} />}
              </span>
            </Link>
          </li>
        )
      })}
    </ul>
  )
}
